import React, { useEffect, useRef, useState } from "react";
import { getDollarFormat } from 'utils/helpers';
import AgGrid from 'screens/components/advanced/AgGrid';

const DataGrid = ({ categoryProducts, showComparison }) => {
    // local state
    const [localRows, setLocalRows] = useState([]);
    
    useEffect(() => {
        if (!showComparison){
            setLocalRows(categoryProducts.list);
        }else{
            const compareData = categoryProducts && categoryProducts.list.map((item, index) => {
                const compare = categoryProducts ? categoryProducts.compare.filter(x => x.categoryId == item.categoryId)[0] : [];
                return{
                    ...item,
                    compareQuantity: compare ? compare.quantity : "",
                    compareCost: compare ? getDollarFormat(compare.cost) : "",
                    compareMarginPercentage: compare ? `${compare.marginPercentage.toFixed(2)}%` : "",
                    compareMarkupPercentage: compare ? `${compare.markupPercentage.toFixed(2)}%` : "",
                };
            })
            setLocalRows(compareData);
        }
            
    }, [showComparison,categoryProducts])

    const toFixedCell = ({ value }) => <span>{value.toFixed(2)}%</span>;
    const costCell = ({ value }) => <span>${value.toFixed(2)}</span>;
    const orangeCell = ({ value }) => <span className="categoryProductCompare">{value}</span>;

    const columnHeaders =  [
        { field: "categoryName", headerName: "Category", sortable: true, minWidth: 100 },
        { field: "quantity", headerName: "Units", sortable: true, minWidth: 100  },
        { field: "cost", headerName: "Total Inventory Cost", sortable: true, minWidth: 100, cellRenderer: costCell  },
        { field: "marginPercentage", headerName: "Margin", sortable: true, cellRenderer: toFixedCell },
        { field: "markupPercentage", headerName: "Markup", sortable: true, minWidth: 140, cellRenderer: toFixedCell }
    ];

    const columnComparisonHeaders =  [
        { field: "categoryName", headerName: "Category", sortable: true, minWidth: 100 },
        { field: "compareQuantity", headerName: "Compare to", sortable: true, minWidth: 100, cellRenderer: orangeCell  },
        { field: "quantity", headerName: "Units", sortable: true, minWidth: 100  },
        { field: "compareCost", headerName: "Compare to", sortable: true, minWidth: 100, cellRenderer: orangeCell  },
        { field: "cost", headerName: "Total Inventory Cost", sortable: true, minWidth: 100, cellRenderer: costCell  },
        { field: "compareMarginPercentage", headerName: "Compare to", sortable: true, cellRenderer: orangeCell },
        { field: "marginPercentage", headerName: "Margin", sortable: true, cellRenderer: toFixedCell },
        { field: "compareMarkupPercentage", headerName: "Compare to", sortable: true, minWidth: 140, cellRenderer: orangeCell },
        { field: "markupPercentage", headerName: "Markup", sortable: true, minWidth: 140, cellRenderer: toFixedCell }
    ];

    return (
        <AgGrid
            columns={!showComparison ? columnHeaders : columnComparisonHeaders}
            rows={localRows}
        />
    );
};

export default DataGrid;